import * as yup from 'yup';

export type PasswordRequirement = {
	re: RegExp;
	// i18n key suffix, to be prefixed with the page namespace (e.g., 'register.' or 'resetPassword.')
	key: string; // e.g., 'errors.newPasswordMinLength'
};

const requirements: PasswordRequirement[] = [
	{ re: /.{8,}/, key: 'errors.newPasswordMinLength' },
	{ re: /\d/, key: 'errors.newPasswordIncludeNumber' },
	{ re: /[a-z]/, key: 'errors.newPasswordIncludeLowercaseLetter' },
	{ re: /[A-Z]/, key: 'errors.newPasswordIncludeUppercaseLetter' },
	{ re: /[$&+,:;=?@#|'<>.^*()%!-]/, key: 'errors.newPasswordIncludeSpecialSymbol' },
];

export default requirements;

const minLength = 8;

export function getStrength(password: string) {
	let multiplier = password.length > minLength ? 0 : 1;

	for (const req of requirements) {
		if (!req.re.test(password)) {
			multiplier += 1;
		}
	}

	return Math.max(100 - (100 / (requirements.length + 1)) * multiplier, 10);
}

export const colors = {
	Success: 'teal',
	Warning: 'yellow',
	Error: 'red',
};

export const yupSchema = yup
	.string()
	.required('errors.newPasswordRequired')
	.min(8, 'errors.newPasswordMinLength')
	.matches(/\d/, 'errors.newPasswordIncludeNumber')
	.matches(/[a-z]/, 'errors.newPasswordIncludeLowercaseLetter')
	.matches(/[A-Z]/, 'errors.newPasswordIncludeUppercaseLetter')
	.matches(/[$&+,:;=?@#|'<>.^*()%!-]/, 'errors.newPasswordIncludeSpecialSymbol');
